import { SerializedFarm } from 'state/types'

/**
 * Returns the first farm with a quote token that matches from an array of preferred quote tokens
 * @param farms Array of farms
 * @param preferredQuoteTokens Array of preferred quote tokens
 * @returns A preferred farm, if found - or the first element of the farms array
 */
export const filterFarmsByQuoteToken = (
  farms: SerializedFarm[],
  preferredQuoteTokens: string[] = ['BUSD', 'FUSD', 'WBNB', 'WBESC'],
): SerializedFarm => {
  if (!farms || farms.length === 0) {
    // keep return type the same; callers already handle falsy
    // @ts-ignore
    return farms?.[0]
  }

  const preferredUpper = preferredQuoteTokens.map((t) => t.toUpperCase())

  const preferredFarm = farms.find((farm) => {
    const sym = farm?.quoteToken?.symbol?.toUpperCase?.()
    return sym ? preferredUpper.includes(sym) : false
  })

  // if no preferred match, fall back to first available farm
  // (safe because farms.length > 0 above)
  return preferredFarm || farms[0]
}

export default filterFarmsByQuoteToken
